import { PageHero } from "@/components/site/PageHero";
import { Reveal, SectionLabel } from "@/components/site/primitives";
import { MapPin, ArrowUpRight } from "lucide-react";
import { PROJECTS, FOOTPRINT } from "@/data/content";

export default function Projects() {
  return (
    <div data-testid="projects-page">
      <PageHero
        label="Projects & Experience"
        titleLines={["Impact,", "delivered", "on the ground"]}
        intro="Consultancy and operational engagements with Urban Local Bodies across northern India — documentation, DPRs, MIS, and digital governance in action."
        testId="projects-hero"
      />

      {/* Footprint */}
      <section data-testid="footprint" className="px-5 md:px-10 py-20 border-b border-raritan-border bg-raritan-green text-white">
        <div className="max-w-[1400px] mx-auto">
          <SectionLabel className="mb-8 text-white/60 [&>span]:bg-raritan-red">Operational presence</SectionLabel>
          <div className="flex flex-wrap gap-x-10 gap-y-4">
            {FOOTPRINT.map((f, i) => (
              <Reveal key={f} delay={i * 0.06}>
                <div className="flex items-center gap-3 group">
                  <MapPin size={22} className="text-raritan-red" />
                  <span className="font-heading font-bold text-2xl md:text-4xl tracking-tight group-hover:text-white/70 transition-colors">{f}</span>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      {/* Project cards */}
      <section className="px-5 md:px-10 py-24 md:py-32">
        <div className="max-w-[1400px] mx-auto">
          <SectionLabel className="mb-6">Selected engagements</SectionLabel>
          <h2 className="font-heading font-black uppercase tracking-tighter text-4xl md:text-6xl text-raritan-ink mb-16">Municipalities & ULBs</h2>
          <div className="grid md:grid-cols-2 gap-px bg-raritan-border border border-raritan-border">
            {PROJECTS.map((p, i) => (
              <Reveal key={p.id} delay={i * 0.07}>
                <div className="bg-raritan-surface p-8 md:p-12 h-full group hover:bg-raritan-green hover:text-white transition-colors duration-500">
                  <div className="flex justify-between items-start mb-8">
                    <span className="font-heading font-black text-5xl text-raritan-red/30 group-hover:text-white/30 transition-colors">{p.id}</span>
                    <ArrowUpRight size={26} className="text-raritan-muted group-hover:text-white group-hover:translate-x-1 group-hover:-translate-y-1 transition-all" />
                  </div>
                  <span className="font-mono text-[11px] uppercase tracking-[0.15em] text-raritan-green group-hover:text-white/70">{p.state}</span>
                  <h3 className="mt-3 font-heading font-bold text-2xl md:text-3xl tracking-tight">{p.name}</h3>
                  <p className="mt-4 inline-block font-mono text-[11px] uppercase tracking-[0.12em] text-raritan-red bg-raritan-green-soft group-hover:bg-white/10 group-hover:text-white px-3 py-1.5 transition-colors">{p.area}</p>
                  <p className="mt-6 font-body text-raritan-muted group-hover:text-white/80 leading-relaxed">{p.desc}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
